/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
import axios from 'axios';
import { setupAxios } from '@carvana/core-auth';
import * as rdd from 'react-device-detect';

export const CV_ACCESS_TOKEN: string = 'CVAccessToken';
export const ASPX_AUTH: string = '.ASPXAUTH';

const isLocalEnvironment: boolean = process.env.CARVANA_APP_IS_LOCAL_ENVIRONMENT === 'true' || false;

function validateAuthResponse(error: any) {
  const isLoggedOut = error.response && error.response.status === 401;

  // account modal instead of redirecting home.
  const isMyCarvanaPath = window.location.pathname.indexOf('my-carvana') !== -1;

  const queryString = window.location.search;
  const parameters = new URLSearchParams(queryString);

  const isLoginModalOpen = parameters.has('openAccountModal');

  const shouldPromptLogin = isLoggedOut && !isLocalEnvironment && isMyCarvanaPath && !isLoginModalOpen;

  if (shouldPromptLogin) {
    if (queryString) {
      const pathname = `${queryString}&openAccountModal=signin`;
      window.location.search = pathname;
    } else {
      window.location.search = '?openAccountModal=signin';
    }
  }
}

const createAxiosInstance = (useInterceptors = true, options = {}) => {
  const timeout = 30000;
  let instance: any = axios.create({ timeout, ...options });

  instance = setupAxios(instance, { addBearerTokenToAllRequests: true });

  if (useInterceptors) {
    instance.interceptors.request.use(
      async (config: any) => {
        const originalConfig = config;

        // add device info
        originalConfig.headers['X-CVNA-Platform'] = rdd.osName;
        originalConfig.headers['X-CVNA-AppVersion'] = rdd.osVersion;
        originalConfig.headers['X-CVNA-DeviceType'] = rdd.deviceType;
        if (rdd.isMobile) {
          originalConfig.headers['X-CVNA-DeviceId'] = rdd.mobileModel;
        } else {
          originalConfig.headers['X-CVNA-DeviceId'] = rdd.browserName;
        }

        return originalConfig;
      },
      (error: any) => {
        // eslint-disable-next-line
        console.error('The My Cars axiosWithAuth has encountered an error: ', error);
        // TODO: Do something with request error
        return Promise.reject(error);
      }
    );
  }

  instance.interceptors.response.use(
    async (response: any) => response.data,
    async (error: any) => {
      if (error && error.response) {
        validateAuthResponse(error);
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

const AxiosWithAuthService = (useIntercepters = true, options = {}) => createAxiosInstance(useIntercepters, options);

export default AxiosWithAuthService;
